import type { Item } from '@/components/SelectFieldComp';
import type { AbsenceReasonDetailSickType } from '@/types/domain/attendContact/valueObjects/absenceReasonDetailSick';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';
import { ABSENCE_REASON_DETAIL_SICK_TYPE } from '@/types/domain/attendContact/valueObjects/absenceReasonDetailSick';

/**
 * 病欠理由
 */
export class AbsenceReasonDetailSick extends PrimitiveValueObject<
  AbsenceReasonDetailSickType
> {
  /**
   * 作成
   * @param props 値
   * @returns 値
   */
  static create(props: AbsenceReasonDetailSickType): AbsenceReasonDetailSick {
    return new AbsenceReasonDetailSick(props);
  }

  /** ラベル */
  static get label(): string {
    return '理由';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 一覧 */
  static get items(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items: Item[] = [];
    for (let i = 0; i < ABSENCE_REASON_DETAIL_SICK_TYPE.length; i += 1) {
      items.push({
        id: ABSENCE_REASON_DETAIL_SICK_TYPE[i],
        name: ABSENCE_REASON_DETAIL_SICK_TYPE[i],
      });
    }
    return items;
  }
}
